import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_LOCAL_AGENCY_STATE,
});

export const syncLocalAgencies = (params) => ({
  type: types.SYNC_LOCAL_AGENCIES.REQUEST,
  params,
});

export const syncLocalAgenciesSuccess = (localAgencies) => ({
  type: types.SYNC_LOCAL_AGENCIES.SUCCESS,
  localAgencies,
});

export const syncLocalAgenciesFailure = (error) => ({
  type: types.SYNC_LOCAL_AGENCIES.FAILURE,
  error,
});
